module.exports = __webpack_public_path__ + "img/trinidad-and-tobago.d282dabb.svg";